<template>
  <div id="order-error">
    <div :class="getClassBody">
      <h4 :class="getStyle">{{ error }}</h4>
      <p>
        {{ descr }}
      </p>
      <div>
        <button class="btn btn-success" v-if="getButtonMessage" @click="onButtonClicked">
          {{ getButtonMessage }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import mobile_detection from "../mixins/mobile_detection";
export default {
  mixins: [mobile_detection],
  props: {
    error: {
      type: String,
      default: null
    },
    level: {
      type: String,
      default: "error"
    },
    descr: {
      type: String,
      default:
        "Por favor, contactate con nosotros telefónicamente! Gracias por tu paciencia!"
    }
  },
  date() {
    return {};
  },
  methods: {
    onButtonClicked () {
      console.log('onButtonClicked')
      this.$emit("onButtonClicked");
    }
  },
  computed: {
    getButtonMessage() {
      return this.$store.getters.getOrderErrorButtonCaption;
    },
    getClassBody() {
      if (this.isMobile()) {
        return "order-error-body-mobile";
      } else {
        return "order-error-body";
      }
    },
    getStyle() {
      switch (this.level) {
        case "success":
          return "label-success";
        default:
          return "label-error";
      }
    }
  }
};
</script>
<style lang="scss">
.label-error {
  color: #e04141;
}
.label-success {
  color: #95dd51;
}
#order-error {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;
}
.order-error-body {
  margin-left: 20%;
  padding: 20px;
  margin-right: 20%;
  background-color: white;
  margin-top: 45vh;
}
.order-error-body-mobile {
  margin-left: 13vw;
  padding: 5vw;
  margin-right: 13vw;
  background-color: white;
  margin-top: 30vh;
  margin-bottom: 30vh;
}
</style>



// WEBPACK FOOTER //
// src/Components/OrderError.vue